import { ReactElement, memo, useState } from "react"
import styled from "styled-components"
import MetricsHeader from "./MetricsHeader"
import ProductsPerformanceTable from "./ProductsPerformanceTable"
import { getDateDaysAgo } from "utils/formatDate"
import MetricsCharts from "./Charts/MetricsCharts"
import MetricsCards from "./Cards/MetricsCards"
import { PeriodFilters } from "constants/metrics"

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.theme.palette.gray_ice};
  margin-top: 48px;
  gap: 32px;
  overflow: hidden;
`
const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
`

export const initialDebouncedFilters: App.MetricsParams = {
  dateStart: getDateDaysAgo(29),
  dateEnd: getDateDaysAgo(0)
}

export const initialFilters: App.MetricsParams = {
  ...initialDebouncedFilters,
  productPrefixUrl: undefined
}

const Metrics = (): ReactElement => {
  const [filters, setFilters] = useState<App.MetricsParams>(initialFilters)
  const [debouncedFilters, setDebouncedFilters] = useState<App.MetricsParams>(initialDebouncedFilters)
  const [periodFilter, setPeriodFilter] = useState<PeriodFilters>(PeriodFilters.THIRTY_DAYS)

  return (
    <Container>
      <InnerContainer>
        <MetricsHeader
          filters={filters}
          debouncedFilters={debouncedFilters}
          setFilters={setFilters}
          setDebouncedFilters={setDebouncedFilters}
          setPeriodFilter={setPeriodFilter}
          periodFilter={periodFilter}
        />
        <MetricsCards filters={filters} />
        <MetricsCharts filters={filters} />
        <ProductsPerformanceTable filters={filters} />
      </InnerContainer>
    </Container>
  )
}

export default memo(Metrics)
